export default class LeaveActivityUseCase {
  constructor(postRepository) {
    this.postRepository = postRepository;
  }

  async execute(postId, userId, participantDetails) {
    if (!postId || !userId) {
      throw new Error('Post ID and User ID are required');
    }

    return this.postRepository.leaveActivity(postId, userId, participantDetails);
  }
} 